"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotFlowService = function BotFlowService(HttpService) {
    "ngInject";

    var getBotFlowsPromise = function getBotFlowsPromise() {
        return HttpService.getPromise("bigfoot/bots/flows");
    };

    return { getBotFlowsPromise: getBotFlowsPromise };
};

exports.default = BotFlowService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/bot-flow.service.js
 **/